import Link from 'gatsby-link';
import * as React from 'react';
export default {
  Link,
  React
};